export default `
mutation DenyTimeOff($shiftId: ID!, $deniedBy: ID!) {
  denyTimeOff(shiftId: $shiftId, deniedBy: $deniedBy) {
    createdAt
    updatedAt
    publishedAt
    acknowledgedAt
    updatedBy
    shiftId
    status
    createdBy
    userId
    isDeleted
    propertyId
    note
    startTime
    endTime
    serviceProviderId
    requests
    divisionId
    requiredLevels
    timezone
  }
}
`;